import { Box } from '@mui/material';
import { useEffect, useRef } from 'react';

interface WidthComponentProps {
  setDropBoxWidth: (width: string) => void;
  children: any;
}

export const WidthComponent = ({
  setDropBoxWidth,
  children,
}: WidthComponentProps) => {
  const componentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateWidth = () => {
      if (componentRef.current) {
        const componentWidth = componentRef.current.offsetWidth;
        setDropBoxWidth(`${componentWidth}px`);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);
  return <Box ref={componentRef}>{children}</Box>;
};
